import Vue from "vue"
import Vuex from "vuex"
import session from "./modules/session"
import utilizador from "./modules/utilizador"
import brigada from "./modules/brigada"
import instituicao from "./modules/instituicao"
import tipo_utilizador from "./modules/tipo_utilizador"
import localidade from "./modules/localidade"
import colheita from "./modules/colheita"
import dadiva from "./modules/dadiva"
import nacionalidade from "./modules/nacionalidade"
import genero from "./modules/genero"
import notificacao from "./modules/notificacao"
import estado_civil from "./modules/estado_civil"
import gs from "./modules/gs"
import galardao from "./modules/galardao"
import galardao_pedido from "./modules/galardao_pedido"
import associado from "./modules/associado"
import utilizador_colheita from "./modules/utilizador_colheita"
import donativo from "./modules/donativo"
import comprovativo from "./modules/comprovativo"
import stats from "./modules/stats"
import termos from "./modules/termos"

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    session,
    utilizador,
    brigada,
    instituicao,
    tipo_utilizador,
    localidade,
    colheita,
    dadiva,
    genero,
    estado_civil,
    nacionalidade,
    gs,
    galardao,
    galardao_pedido,
    associado,
    utilizador_colheita,
    donativo,
    comprovativo,
    stats,
    notificacao,
    termos
  },
  strict: false
})
